export default __webpack_public_path__ + "static/media/0xf239e69ce434c7fb408b05a0da416b14917d934e.55117711.webp";